// src/components/Charts/pie/MostUsedIcdsPieChart.jsx
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AnalyticsPieCard from './AnalyticsPieCard';
import { BASE_PIE_COLORS, OTHERS_COLOR } from '../../../constants/ColorsPalette';
import { urls } from '../../config/variables';
import AppContext from '../../../contexts/app-context';
import AuthContext from '../../../contexts/auth-context';

export default function MostUsedIcdsPieChart({ chartId }) {
  const { t } = useTranslation('analytics');
  useContext(AppContext);
  useContext(AuthContext);

  return (
    <AnalyticsPieCard
      chartId={chartId}
      endpoint={urls.ICDS_COUNT}
      i18n={{
        seriesName: t('MostUsedIcds') || 'Most Used ICDs',
        centerLabel: t('Icds') || 'ICDs',
        detailsButton: 'ICDs Details',
        dialogTitle: 'All ICDs',
        entityName: 'ICD',
        noData: t('NoData') || 'No data',
      }}
      nameKeys={['icd_code', 'name']}
      valueKeys={['icd_count', 'count']}
      parseResponse={(data) => {
        // New format: array
        if (Array.isArray(data)) return { rows: data, otherSum: 0 };
        // Old format with other_icds sum
        if (data && Array.isArray(data.most_used_icds)) {
          const otherSum = Number(data.other_icds?.icd_count_sum) || 0;
          return { rows: data.most_used_icds, otherSum };
        }
        console.error('Unexpected response shape for ICDs:', data);
        return { rows: [], otherSum: 0 };
      }}
      baseColors={BASE_PIE_COLORS}
      othersColor={OTHERS_COLOR}
      othersLabel="Others"
      useTopNWithOthers
      topN={14}
    />
  );
}